import React, { useEffect, useState } from "react";

import { Link, useParams } from "react-router-dom";
import { decodeId } from "../../utills/idUtils";
import FancyLoader from "../../hooks/FancyLoder";
import {
  getAsmtById,
  getComponentWiseAvgScore,
} from "../../services/authService";

const CaveatAndNote = ({ onDownalod, isGeneratingPdf, assessment_type }) => {
  const { encodedId } = useParams();
  const id = decodeId(encodedId);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [averageScore, setAverageScore] = useState(0);
  const [scoreCategory, setScoreCategory] = useState("");
  const [asmtType, setAsmtType] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const asmtData = await getAsmtById(id);
        setAsmtType(asmtData.assessment_type);
        const is360 = asmtData.assessment_type === "360";
        const response = await getComponentWiseAvgScore(id); // Fetch component-wise average scores
        const scores = is360
          ? response.data.filter(
            (score) => score.association_type === "participant"
          )
          : response.data;

        // Process scores
        const processedScores = scores.map((score) => ({
          ...score,
          avgScore: parseFloat(score["sum(aua.answer_value)"]),
        }));

        const totalScore = processedScores.reduce(
          (sum, score) => sum + (score.avgScore || 0),
          0
        );

        const avgScore = totalScore;

        // Determine score category
        // if (avgScore > 80) {
        //   setScoreCategory("Excellent");
        // } else if (avgScore >= 48) {
        //   setScoreCategory("Average");
        // } else {
        //   setScoreCategory("Below Average");
        // }

        if (avgScore >= 70) {
          setScoreCategory("Excellent");
        } else if (avgScore >= 41) {
          setScoreCategory("Average");
        } else {
          setScoreCategory("Below Average");
        }
        // setScoreCategory("Excellent");

      } catch (err) {
        // Handle error
        console.error(err.response ? err.response.data.message : err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) {
    return (
      <div>
        <FancyLoader />
      </div>
    );
  }

  const handleShare = async () => {
    const shareData = {
      title: "Check this out!",
      text: "I found this interesting, take a look:",
      url: `${window.location.origin}/report/${encodedId}`, // Share the custom URL instead of the current page URL
    };

    try {
      // Check if the Web Share API is supported
      if (navigator.share) {
        await navigator.share(shareData);
        //console.log('Successfully shared');
      } else {
        // Fallback if Web Share API is not supported
        alert(
          "Web Share API is not supported in your browser. Try copying the link manually."
        );
      }
    } catch (error) {
      console.error("Error sharing:", error);
    }
  };

  return (
    <>
      {isGeneratingPdf ? (
        <>
          {/* {assessment_type === "360" && <div style={{ pageBreakAfter: 'always' }}></div>} */}
            <div style={{ pageBreakAfter: 'always' }}></div>
          <div className="lg:px-16 p-4 pt-0 mt-5">
            <div className="flex flex-wrap bg-[#F0F0F0] rounded-lg" style={{ background: "rgb(230 230 230  / var(--tw-bg-opacity, 1))" }}>

              <div className=" rounded-bl-md rounded-br-md rounded-lg pb-0 ">
                {/* Caveats & Notes Section */}
                <div className="bg-blue-200 text-black p-2 mt-4">
                  <h1
                    className="text-blue-800 text-xl font-bold"
                    style={{ fontFamily: "Helvetica" }}
                  >
                    Caveats & Notes
                  </h1>
                </div>

                <div
                  className="bg-[#BFDBFE] p-4 rounded-md  m-8"
                  style={{
                    fontFamily: "Helvetica",
                    background: "rgb(207 225 254 / var(--tw-bg-opacity, 1))",
                  }}
                >
                  <p style={{ fontFamily: "Helvetica" }}>
                    Be aware that sometimes a strength overused can become a
                    weakness. Review your scores to identify traits where you are
                    scoring too high and reflect on whether you are leveraging that
                    strength in the right context.
                  </p>
                  <p className="mt-2" style={{ fontFamily: "Helvetica" }}>
                    Behaviour can be both functional and dysfunctional, depending on
                    the context. Pay special attention to the derailer elements in
                    your EP Assessment. Negative traits/behaviours can have three
                    times more (negative) impact than positive ones. Unlearning is
                    also learning, so identify a few dysfunctional behaviours to
                    stop enacting.
                  </p>
                </div>
                {/* Next Steps Section */}
                {scoreCategory !== "Excellent" && (
                  <div className=" p-4 rounded-md ">
                    <h2
                      className="text-black text-2xl font-bold text-center"
                      style={{ fontFamily: "Helvetica" }}
                    >
                      Next Steps: Enhancing Your Executive Presence
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4">
                      {[
                        {
                          icon: "fa-check",
                          title: "Review your feedback",
                          text: "Reflect on your strengths and areas for improvement highlighted in this report.",
                        },
                        {
                          icon: "fa-bullseye",
                          title: "Set Goals",
                          text: "Set clear, actionable goals based on the key areas identified for development.",
                        },
                        {
                          icon: "fa-user-tie",
                          title: "Engage a Coach",
                          text: "Work with an executive coach to get personalized guidance.",
                        },
                        {
                          icon: "fa-chart-line",
                          title: "Track Your Progress",
                          text: "Keep track of your growth and stay committed to your development.",
                        },
                      ].map((step, index) => (
                        <div
                          key={index}
                          className="bg-gray-300  p-4 rounded-md text-center"
                        // style={{background:'rgb(209 206 206)'}}
                        >
                          <div
                            className="text-2xl mb-2"
                            style={{ fontFamily: "Helvetica" }}
                          >
                            <i className={`fa-solid ${step.icon}`}></i>
                          </div>
                          <h3
                            className="font-bold"
                            style={{ fontFamily: "Helvetica" }}
                          >
                            {step.title}
                          </h3>
                          <div
                            className="bg-white-500 text-black p-2 mt-2 text-justify rounded-md"
                            style={{ fontFamily: "Helvetica" }}
                          >
                            {step.text}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Action Items Section */}
                <div className="  my-8 rounded-md">
                  {scoreCategory === "Excellent" && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4 p-4">
                      {[
                        {
                          icon: "fa-check",
                          title: "Leverage Your Strengths",
                          text: "Continue to lead and inspire others with your exceptional presence.",
                        },
                        {
                          icon: "fa-bullseye",
                          title: "Seek Challenges",
                          text: "Take on high-impact projects to further showcase your skills.",
                        },
                        {
                          icon: "fa-network-wired",
                          title: "Expand Your Network",
                          text: "Strengthen relationships with senior leaders and key stakeholders.",
                        },
                        {
                          icon: "fa-user-tie",
                          title: "Engage a Coach",
                          text: "Work with an executive coach to discuss further growth strategies.",
                        },
                      ].map((item, index) => (
                        <div
                          key={index}
                          className="bg-gray-300 p-4 rounded-lg  text-center"
                          style={{ background: 'rgb(209 206 206)' }}
                        >
                          <div
                            className="text-2xl font-bold mb-4"
                            style={{ fontFamily: "Helvetica" }}
                          >
                            <i className={`fa-solid ${item.icon}`}></i>
                          </div>
                          <div
                            className="font-bold mb-4"
                            style={{ fontFamily: "Helvetica" }}
                          >
                            {item.title}
                          </div>
                          <div
                            className="bg-white-500 text-black p-4 rounded-lg"
                            style={{ fontFamily: "Helvetica" }}
                          >
                            {item.text}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="lg:px-16 p-4 pt-0 mt-8">
          <div className="flex flex-wrap bg-[#F0F0F0] rounded-lg" style={{ background: "rgb(230 230 230  / var(--tw-bg-opacity, 1))" }}>

            <div className=" rounded-bl-md rounded-br-md pb-0 ">
              {/* Caveats & Notes Section */}



              <div className="bg-blue-600 p-2 mt-4 text-left  text-white text-lg font-bold " style={{ paddingBottom: "5px", fontFamily: 'Helvetica' }}>
                Caveats & Notes
              </div>


              <div className="bg-[#BFDBFE] p-4 rounded-md  m-8">
                <p style={{ fontFamily: "Helvetica" }}>
                  Be aware that sometimes a strength overused can become a
                  weakness. Review your scores to identify traits where you are
                  scoring too high and reflect on whether you are leveraging that
                  strength in the right context.
                </p>
                <p className="mt-2" style={{ fontFamily: "Helvetica" }}>
                  Behaviour can be both functional and dysfunctional, depending on
                  the context. Pay special attention to the derailer elements in
                  your EP Assessment. Negative traits/behaviours can have three
                  times more (negative) impact than positive ones. Unlearning is
                  also learning, so identify a few dysfunctional behaviours to
                  stop enacting.
                </p>
              </div>

              {/* Next Steps Section */}
              {scoreCategory !== "Excellent" && (
                <div className=" p-4 mt-4 rounded-md ">
                  <h2
                    className="text-black text-2xl font-bold text-center"
                    style={{ fontFamily: "Helvetica" }}
                  >
                    Next Steps: Enhancing Your Executive Presence
                  </h2>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4">
                    {[
                      {
                        icon: "fa-check",
                        title: "Review your feedback",
                        text: "Reflect on your strengths and areas for improvement highlighted in this report.",
                      },
                      {
                        icon: "fa-bullseye",
                        title: "Set Goals",
                        text: "Set clear, actionable goals based on the key areas identified for development.",
                      },
                      {
                        icon: "fa-user-tie",
                        title: "Engage a Coach",
                        text: "Work with an executive coach to get personalized guidance.",
                      },
                      {
                        icon: "fa-chart-line",
                        title: "Track Your Progress",
                        text: "Keep track of your growth and stay committed to your development.",
                      },
                    ].map((step, index) => (
                      <div
                        key={index}
                        className="bg-gray-300  p-4 rounded-md text-center"
                      >
                        <div className="text-2xl mb-2">
                          <i className={`fa-solid ${step.icon}`}></i>
                        </div>
                        <h3
                          className="font-bold"
                          style={{ fontFamily: "Helvetica" }}
                        >
                          {step.title}
                        </h3>
                        <div
                          className="bg-white-500 text-black p-2 mt-2 text-justify rounded-md"
                          style={{ fontFamily: "Helvetica" }}
                        >
                          {step.text}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Action Items Section */}
              <div className="  my-8 rounded-md">
                {scoreCategory === "Excellent" && (
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4 p-4">
                    {[
                      {
                        icon: "fa-check",
                        title: "Leverage Your Strengths",
                        text: "Continue to lead and inspire others with your exceptional presence.",
                      },
                      {
                        icon: "fa-bullseye",
                        title: "Seek Challenges",
                        text: "Take on high-impact projects to further showcase your skills.",
                      },
                      {
                        icon: "fa-network-wired",
                        title: "Expand Your Network",
                        text: "Strengthen relationships with senior leaders and key stakeholders.",
                      },
                      {
                        icon: "fa-user-tie",
                        title: "Engage a Coach",
                        text: "Work with an executive coach to discuss further growth strategies.",
                      },
                    ].map((item, index) => (
                      <div
                        key={index}
                        className="bg-gray-300 p-4 rounded-lg  text-center"
                      >
                        <div className="text-2xl font-bold mb-4">
                          <i className={`fa-solid ${item.icon}`}></i>
                        </div>
                        <div className="font-bold mb-4">{item.title}</div>
                        <div className="bg-white-500 text-black p-4 rounded-lg">
                          {item.text}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* <div className="text-center mb-4">
  <span
    id='downloadingBtn'
    className="downloadingBtn hidden text-center text-white bg-green-500 py-2 px-4 ml-2 rounded-lg"
  >
    Downloading
  </span>
  <button
    id="downloadButton"
    onClick={onDownalod}
    className="bg-green-500 downloadButton  text-white py-2 px-4 rounded-lg hide-for-pdf "
  >
    Download Report As PDF
  </button>

  <br />
  <p id='apttext' className="mt-4 hide-for-pdf">
    Make an appointment with Coach Kshitij to explore one-on-one Executive Coaching.
  </p>
  <a rel="noreferrer" href="https://coachkshitij.com/make-appointment/" target='_blank' className="mt-4 inline-block bg-white text-blue-600 font-bold py-2 px-4 rounded-lg  hover:bg-gray-100 transition duration-300">
    <button id="appointmentButton"
      className="bg-blue-500 hideIt text-white py-2 px-4 rounded-lg mt-4 hide-for-pdf">
      Make an appointment
    </button>
  </a>

  <div class="flex justify-center space-x-4 mt-8">
  
    <Link id='hme' to="/">
      <button className="bg-blue-500 text-white font-medium py-2 px-6 rounded-lg hover:bg-gray-500 transition">Home</button>
    </Link>
  </div>
</div> */}
        </div>
      )}
    </>
  );
};

export default CaveatAndNote;
